module.exports = __webpack_public_path__ + "assets/img/order-empty.c3fbb7f6.png";